import { render, staticRenderFns } from "./TitleSummaryBrief.vue?vue&type=template&id=bc3b8ba0&scoped=true&"
import script from "./TitleSummaryBrief.vue?vue&type=script&lang=js&"
export * from "./TitleSummaryBrief.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3b8ba0",
  null
  
)

export default component.exports